import { Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)`
    border-radius: 6px;
    overflow: hidden;
    padding: 0;
    min-width: 80ch;

    .ant-modal-footer {
        padding: 0;
    }

    .ant-modal-title {
        font-weight: 600;
        color: var(--brand-9);
        font-size: 20px;
        line-height: 28px;
    }
`;

export const StyledModalFooter = styled.footer`
    padding: 12px 24px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
`;

export const StyledIconWrapper = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    width: 64px;
    height: 64px;
    font-size: 120px;

    color: var(--brand-6);
    background-color: var(--brand-1);
`;
